import Order from './pdfImages/order.jpg';
import Pickup from './pdfImages/pickup.jpg';
import Keycard from './pdfImages/keycard.jpg';
import Internal from './pdfImages/internal.jpg';
import ETicket from './pdfImages/eticket.jpg';
import Cancel from './pdfImages/cancel.jpg';
import KeycardProduced from './pdfImages/keycardProduced.jpg';
import TicketETicket from './pdfImages/ticketETicket.jpg';

export const mailTextConfig = {
    Order: {
        sort: 1,
        name: 'E-Mail Vorlage:  Bestelleingang',
        description:
            'Diese E-Mail wird bei jeder Bestellung als Zusammenfassung der gesamten Bestellung übermittelt. Darauf folgt immer eine 2. E-Mail pro Ticket mit der Bestätigung – je nach gewählter Buchungsoption.\n' +
            'Dies ist noch KEINE Bestätigung der Buchung.',

        image: Order,
        variables: {
            SUBJECT: {
                sort: 1,
                name: 'Ihr Text für 1 – E-Mail-Betreff:',
            },

            INTRO1: {
                sort: 2,
                name: 'Ihr Text für 2a – Einleitung:',
            },

            INTRO2: {
                sort: 3,
                name: 'Ihr Text für 2b – Einleitung:',
            },

            INFO_TICKET: {
                sort: 4,
                name: 'Ihr Text für 3 – Info Bestätigung:',
            },

            INFO_KEYCARD: {
                sort: 5,
                name: 'Ihr Text für 4 – Info Keycard:',
            },

            OUTRO: {
                sort: 6,
                name: 'Ihr Text für 5 – Abschluss:',
            },
        },
    },

    TicketKeycard: {
        sort: 2,
        name: 'E-Mail Vorlage:  Bestätigung Keycard-Buchung',
        description:
            'Wird bei Ticketbuchung auf eine Keycard als Bestätigung versandt.',

        image: Keycard,
        variables: {
            SUBJECT: {
                sort: 1,
                name: 'Ihr Text für 1 – E-Mail-Betreff:',
            },

            INTRO: {
                sort: 2,
                name: 'Ihr Text für 2 – Einleitung:',
            },

            HINT: {
                sort: 3,
                name: 'Ihr Text für 4 – Info zur Nutzung:',
            },

            WARNING: {
                sort: 4,
                name: 'Ihr Text für 5 – Info Nachweis:',
            },

            OUTRO: {
                sort: 5,
                name: 'Ihr Text für 5 – Abschluss:',
            },
        },
    },

    TicketPickup: {
        sort: 3,
        name: 'E-Mail Vorlage:  Bestätigung pick-up-Voucher',
        description:
            'Wird bei Ticketbuchung mit der Option „pick-up-Voucher“ als Bestätigung versandt.  Der Voucher muss bei Ihnen vor Ort gegen ein gültiges Zutrittsticket getauscht werden.\n' +
            'Unser Tipp: Platzieren Sie im Text die info, wo der Gast seinen Voucher gegen ein Ticket eintauschen kann. (z.B. pick-up-Automat bei der Talstation XY…)',

        image: Pickup,
        variables: {
            SUBJECT: {
                sort: 1,
                name: 'Ihr Text für 1 – E-Mail-Betreff:',
            },

            INTRO: {
                sort: 2,
                name: 'Ihr Text für 2 – Einleitung:',
            },

            RECOMMENDATION: {
                sort: 3,
                name: 'Ihr Text für 3 – Info Ticket-Ausdruck:',
            },

            HINT: {
                sort: 4,
                name: 'Ihr Text für 4 – Info zur Nutzung:',
            },

            WARNING: {
                sort: 5,
                name: 'Ihr Text für 4 – Info Nachweis:',
            },

            OUTRO: {
                sort: 5,
                name: 'Ihr Text für 5 – Abschluss:',
            },
        },
    },

    TicketBarcode: {
        sort: 4,
        name: 'E-Mail Vorlage:  Bestätigung e-Ticket',
        description:
            'Wird bei Ticketbuchung mit der Option „e-Ticket“ als Bestätigung versandt. Das Ticket wird zum direkten Zutritt beim Lift genutzt.',

        image: ETicket,
        variables: {
            SUBJECT: {
                sort: 1,
                name: 'Ihr Text für 1 – E-Mail-Betreff:',
            },

            INTRO: {
                sort: 2,
                name: 'Ihr Text für 2 – Einleitung:',
            },

            HINT: {
                sort: 3,
                name: 'Ihr Text für 4 – Info zur Nutzung:',
            },

            RECOMMENDATION: {
                sort: 4,
                name: 'Ihr Text für 3 – Info Ticket-Ausdruck:',
            },

            WARNING: {
                sort: 5,
                name: 'Ihr Text für 4 – Info Nachweis:',
            },

            OUTRO: {
                sort: 5,
                name: 'Ihr Text für 5 – Abschluss:',
            },
        },
    },

    TicketETicket: {
        sort: 5,
        name: 'E-Mail Vorlage:  Bestätigung Smartphone Ticket',
        description:
            'Wird bei Ticketbuchung mit der Option „Smartphone Ticket“ als Bestätigung versandt.',
        image: TicketETicket,
        variables: {
            SUBJECT: {
                sort: 1,
                name: 'Ihr Text für 1 – E-Mail-Betreff:',
            },

            INTRO: {
                sort: 2,
                name: 'Ihr Text für 2 – Einleitung:',
            },

            IMPORTANT: {
                sort: 3,
                name: 'Ihr Text für 3 – Info Ticket-Aktivierung:',
            },

            HINT: {
                sort: 4,
                name: 'Ihr Text für 4 – Info zur Nutzung:',
            },

            OUTRO: {
                sort: 5,
                name: 'Ihr Text für 5 – Abschluss:',
            },
        },
    },

    TicketInternal: {
        sort: 6,
        name: 'E-Mail Vorlage:  Keycardproduktion & Versand über Sie',
        description:
            'Wird bei Ticketbuchung mit der Option „interne Produktion“ als Bestätigung versandt.  Diese Buchungsoption wird nur in Ausnahmefällen aktiviert, wir empfehlen vorab ein Gespräch mit starjack, auch wegen der benötigten Hard- und Software',

        image: Internal,
        variables: {
            SUBJECT: {
                sort: 1,
                name: 'Ihr Text für 1 – E-Mail-Betreff:',
            },

            INTRO1: {
                sort: 2,
                name: 'Ihr Text für 2a – Einleitung:',
            },

            INTRO2: {
                sort: 3,
                name: 'Ihr Text für 2b – Einleitung:',
            },

            INFO1: {
                sort: 4,
                name: 'Ihr Text für 3 – Info Zusendung:',
            },

            INFO2: {
                sort: 5,
                name: 'IIhr Text für 4 – Info Rückfragen:',
            },

            OUTRO: {
                sort: 6,
                name: 'Ihr Text für 5 – Abschluss:',
            },
        },
    },

    TicketCancellation: {
        sort: 7,
        name: 'E-Mail Vorlage:  Rückgabe Ticket (Stornierung)',
        description:
            'Der Gast erhält bei der Rückgabe-Option den Ticketwert als Guthaben in sein Webshop Konto, bei der nächsten Buchung wird das Guthaben automatisch zur Zahlung verwendet.',

        image: Cancel,
        variables: {
            SUBJECT: {
                sort: 1,
                name: 'Ihr Text für 1 – E-Mail-Betreff:',
            },

            INTRO: {
                sort: 2,
                name: 'Ihr Text für 2 – Einleitung:',
            },

            HINT: {
                sort: 3,
                name: 'Ihr Text für 3 – Info Rückbuchung:',
            },

            OUTRO: {
                sort: 4,
                name: 'Ihr Text für 5 – Abschluss:',
            },
        },
    },

    KeycardProduced: {
        sort: 8,
        name: 'E-Mail Vorlage: Bestätigung Keycard Versand',
        description:
            'Diese E-Mail wird beim Versand der Keycard als Info an den Gast versendet.',

        image: KeycardProduced,
        variables: {
            TEXT1: {
                sort: 1,
                name: 'Ihr Text 1 - E-Mail Betreff: (Ansicht Mustervorlage)',
            },

            TEXT2: {
                sort: 2,
                name: 'Ihr Text 2 - Anrede: (Ansicht Mustervorlage)',
            },

            TEXT3: {
                sort: 3,
                name: 'Ihr Text 3 - Einleitung: (Ansicht Mustervorlage)',
            },

            TEXT4: {
                sort: 4,
                name: 'Ihr Text 4 – Versandinfo: (Ansicht Mustervorlage)',
            },

            TEXT5: {
                sort: 5,
                name: 'Ihr Text 5: Info Dauer der Zustellung/ Funktion (Ansicht Mustervorlage)',
            },

            TEXT6: {
                sort: 6,
                name: 'Ihr Text 6 – Info Keycard im Webshop Konto hinterlegt: (Ansicht Mustervorlage)',
            },

            OUTRO: {
                sort: 7,
                name: 'Ihr Text 6 – Abschluss (Ansicht Mustervorlage)',
            },
        },
    },
};

export type MailTextConfig = typeof mailTextConfig;
export type MailTextConfigKey = keyof MailTextConfig;
